// src/upc.ts
function ean13CheckDigit(first12) {
  if (!/^\d{12}$/.test(first12)) {
    throw new Error("Input must be exactly 12 digits");
  }
  let odd = 0;
  let even = 0;
  for (let i = 0; i < 12; i++) {
    const digit = first12.charCodeAt(i) - 48;
    if (i % 2 === 0) {
      odd += digit;
    } else {
      even += digit;
    }
  }
  const total = odd + 3 * even;
  return (10 - total % 10) % 10;
}
function generateWeightBarcode(baseUpc, weightInGrams) {
  if (!/^20\d{5}$/.test(baseUpc)) {
    throw new Error("Base UPC must be 7 digits starting with '20'");
  }
  if (weightInGrams < 0 || weightInGrams > 99999) {
    throw new Error("Weight must be between 0 and 99999 grams");
  }
  const weightStr = weightInGrams.toString().padStart(5, "0");
  const first12 = baseUpc + weightStr;
  const checkDigit = ean13CheckDigit(first12);
  return first12 + checkDigit;
}

export {
  ean13CheckDigit,
  generateWeightBarcode
};
